(function () {
  function init(root) {
    if (root.dataset.hbcuReady) return;
    root.dataset.hbcuReady = 'true';
    var grid = root.querySelector('[data-hbcu-grid]');
    if (!grid) return;
    var cards = Array.from(grid.querySelectorAll('[data-hbcu-product]'));
    var buttons = Array.from(root.querySelectorAll('[data-hbcu-filter]'));
    var family = 'all';
    function update() {
      var count = 0;
      cards.forEach(function (card) {
        card.hidden = family !== 'all' && card.dataset.family !== family;
        if (!card.hidden) count++;
      });
      buttons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.hbcuFilter === family)); });
      root.querySelector('[data-hbcu-count]').textContent = count + (count === 1 ? ' style' : ' styles');
      root.querySelector('[data-hbcu-empty]').hidden = count > 0;
    }
    buttons.forEach(function (button) { button.addEventListener('click', function () { family = button.dataset.hbcuFilter; update(); }); });
  }
  document.querySelectorAll('[data-hbcu-shop]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-hbcu-shop]').forEach(init); });
})();
